/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockDetailExportDto
 */
export interface StockDetailExportDto {
    /**
     * SKU ID（SKU 编码）
     * @type {string}
     * @memberof StockDetailExportDto
     */
    skuId?: string;
    /**
     * 仓库
     * @type {string}
     * @memberof StockDetailExportDto
     */
    warehouseName?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof StockDetailExportDto
     */
    marketProNm?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof StockDetailExportDto
     */
    marketOptionNm?: string;
    /**
     * 商品条码
     * @type {string}
     * @memberof StockDetailExportDto
     */
    marketBarcode?: string;
    /**
     * 商品选项 ID
     * @type {string}
     * @memberof StockDetailExportDto
     */
    marketOptionId?: string;
    /**
     * 库存数量
     * @type {number}
     * @memberof StockDetailExportDto
     */
    stockQty?: number;
    /**
     * 已出库数量
     * @type {number}
     * @memberof StockDetailExportDto
     */
    outboundQty?: number;
}

/**
 * Check if a given object implements the StockDetailExportDto interface.
 */
export function instanceOfStockDetailExportDto(value: object): value is StockDetailExportDto {
    return true;
}

export function StockDetailExportDtoFromJSON(json: any): StockDetailExportDto {
    return StockDetailExportDtoFromJSONTyped(json, false);
}

export function StockDetailExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockDetailExportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionNm': json['marketOptionNm'] == null ? undefined : json['marketOptionNm'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'stockQty': json['stockQty'] == null ? undefined : json['stockQty'],
        'outboundQty': json['outboundQty'] == null ? undefined : json['outboundQty'],
    };
}

export function StockDetailExportDtoToJSON(json: any): StockDetailExportDto {
    return StockDetailExportDtoToJSONTyped(json, false);
}

export function StockDetailExportDtoToJSONTyped(value?: StockDetailExportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'warehouseName': value['warehouseName'],
        'marketProNm': value['marketProNm'],
        'marketOptionNm': value['marketOptionNm'],
        'marketBarcode': value['marketBarcode'],
        'marketOptionId': value['marketOptionId'],
        'stockQty': value['stockQty'],
        'outboundQty': value['outboundQty'],
    };
}

